import axios from "axios"
import { API_BASE_URL } from "../../../config/apiConfig"

const getAllFile = async () => {
    const response = await axios.get(`${API_BASE_URL}/file/`)
    console.log("Files", response.data);
    if (response.data) {
        return response.data
    }
}

const getFile = async (reqData) => {
    const { fileId } = reqData
    const response = await axios.get(`${API_BASE_URL}/file/${fileId}`)
    console.log("File Details", response.data);
    if (response.data) {
        return response.data
    }
}

export const fileService = {
    getAllFile,
    getFile,
}
